<template lang="pug">
    .slider-wrapper
        .colors-slider
            .color-title {{activeSlide ? activeSlide.title : ''}}
            .button.prev(@click="onPrevClick")
            .slider-width(:class="{'slider-width-interior': slides.length === 2}")
                swiper(:options="swiperOptions", ref="slider")
                    swiper-slide(v-for="(slide) in slides", :key="slide.id")
                        color-slide(:data="slide", @click="onSlideClick", :active="activeSlide && activeSlide.id === slide.id")
            .button.next(@click="onNextClick")
</template>
<script>
import ColorSlide from "./ColorsSlider/ColorSlide";
export default {
  name: 'ColorsSlider',
  components: {ColorSlide},
  props: ['slides', 'activeSlide'],
  data() {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        updateOnWindowResize: true,
      },
    }
  },


  methods: {

    onSlideClick(data) {
      this.$emit('select', data);
    },

    onPrevClick() {
      this.$refs.slider.$swiper.slidePrev()
    },

    onNextClick() {
      this.$refs.slider.$swiper.slideNext()
    }
  }
}
</script>